<template>
  <button
    :class="[
      baseClasses,
      variantClasses[props.variant],
      sizeClasses[props.size],
      { 'opacity-50 cursor-not-allowed': props.disabled }
    ]"
    :disabled="props.disabled"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { defineProps, PropType } from 'vue';

const props = defineProps({
  variant: {
    type: String as PropType<'primary' | 'secondary' | 'ghost'>,
    required: false,
    default: 'primary',
  },
  size: {
    type: String as PropType<'sm' | 'md' | 'lg'>,
    required: false,
    default: 'md',
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-md transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2';

const variantClasses = {
  primary: `
    bg-primary text-white hover:bg-primaryHover focus-visible:outline-primaryFocus
    dark:bg-white dark:text-primary dark:hover:bg-primary/20 dark:focus-visible:outline-white
  `,
  secondary: `
    bg-white text-primary border border-primary hover:bg-primary/10
    dark:bg-transparent dark:text-white dark:border-white dark:hover:bg-white/10
  `,
  ghost: `
    bg-transparent text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-white/10
  `,
};

const sizeClasses = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-5 py-2.5 text-lg',
};
</script>
